import { useState } from "react";

import FailedSubscriptionPopup from "~/components/failedSubscriptionPopup";
import Filter from "~/components/ui/filter";
import { useAuth } from "~/contexts/providers/auth";
import { useLanguage } from "~/contexts/providers/language";
import {
  AccountSectionEnum,
  AccountSectionEnumEn,
} from "~/types/account/account.types";
import {
  UserStatus,
  UserSubscriptionStatus,
  UserType,
} from "~/types/auth/userEnums.types";
import { EventType } from "~/types/event/event.types";
import { SubscriptionStatus } from "~/types/subscription/subscription.types";
import { TagType } from "~/types/tag/tag.types";
import { getAccountSectionsByLanguage } from "~/utils/constants/account";

import Agenda from "../agenda";
import Birthday from "../birthday";
import Membership from "../membership";
import Programme from "../programme";
import Sponsorship from "../sponsoship";
import SubscriptionSuggestionPopup from "../subscriptionSuggestionPopup";
import styles from "./index.module.scss";

interface Props {
  events: EventType[];
  tags: TagType[];
}

const $7Days = 6048e5; // 7 days in milliseconds = 1000 * 60 * 60 * 24 * 7

const AccountDisplay = ({ events, tags }: Props) => {
  const [filter, setFilter] = useState<
    AccountSectionEnum | AccountSectionEnumEn
  >(AccountSectionEnum.PROGRAMMATION);

  const { language } = useLanguage();

  const { user } = useAuth();

  const validatedUserWithoutSubscription =
    user?.status === UserStatus.VALIDATED &&
    user.subscriptionStatus === UserSubscriptionStatus.NONE;

  const userWithFailedSubscription =
    user &&
    user.status === UserStatus.VALIDATED &&
    user.subscription?.subscriptionStatus === SubscriptionStatus.FAILED &&
    !!user.subscription.failedDate &&
    new Date().getTime() - new Date(user.subscription.failedDate).getTime() >
      $7Days;

  const userLimitedAccess =
    validatedUserWithoutSubscription ||
    userWithFailedSubscription ||
    user?.status !== UserStatus.VALIDATED;

  const accountSectionPages: Record<
    AccountSectionEnum | AccountSectionEnumEn,
    JSX.Element
  > = {
    Programmation: <Programme events={events} tags={tags} />,
    Agenda: <Agenda />,
    Membership: <Membership />,
    Parrainage: <Sponsorship />,
    Anniversaire: <Birthday />,
    Sponsorship: <Sponsorship />,
    Birthday: <Birthday />,
  };
  // const accountSectionPagesEn: Record<AccountSectionEnumEn, JSX.Element> = {
  //   Programmation: <Programme events={events} tags={tags} />,
  //   Agenda: <Agenda />,
  //   Membership: <Membership />,

  // };

  const handleSetFilter = (
    filterName: AccountSectionEnum | AccountSectionEnumEn
  ) => {
    setFilter(filterName);
  };

  if (userLimitedAccess) {
    return (
      <>
        {accountSectionPages.Membership}
        {userWithFailedSubscription && (
          <FailedSubscriptionPopup
            firstName={user.firstname}
            lastName={user.lastname}
          />
        )}
      </>
    );
  }

  return (
    <>
      <div className={styles.accountFilterSection}>
        <Filter<AccountSectionEnum | AccountSectionEnumEn>
          items={getAccountSectionsByLanguage(language)}
          hiddenItems={
            user?.type === UserType.PRE_SELECTED
              ? [AccountSectionEnum.BIRTHDAY]
              : undefined
          }
          filteredItems={[filter]}
          handleSetFilter={handleSetFilter}
          className={styles.filter}
          mapToName={(section) => section}
        />
      </div>

      {accountSectionPages[filter]}
      <SubscriptionSuggestionPopup />
    </>
  );
};

export default AccountDisplay;
